var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8332 13.6667H2.33317C1.40817 13.6667 0.666504 12.9167 0.666504 12V2.00001C0.666504 1.07501 1.40817 0.333344 2.33317 0.333344H7.33317L8.99984 2.00001H14.8332C15.2752 2.00001 15.6991 2.1756 16.0117 2.48817C16.3242 2.80073 16.4998 3.22465 16.4998 3.66668H2.33317V12L4.1165 5.33334H18.3415L16.4415 12.4167C16.2498 13.1417 15.5998 13.6667 14.8332 13.6667Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7c38700814ad8099b1aa5175ab11f909.svg";
export { ForwardRef as ReactComponent };